import styled from 'styled-components';

export const StyledSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  label {
    font-size: var(--font-size-sm);
    font-weight: 500;
    color: var(--color-text);
  }
`;

export const StyledLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary);
`;

export const StyledSelect = styled.select`
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid var(--color-border);
  background-color: var(--color-background);
  font-size: 14px;
  color: var(--color-text-primary);

  &:disabled {
    background-color: var(--color-disabled);
    cursor: not-allowed;
  }
`;
